import { render, staticRenderFns } from "./MessageIndex.vue?vue&type=template&id=0ab5d266&scoped=true&"
import script from "./MessageIndex.vue?vue&type=script&lang=ts&"
export * from "./MessageIndex.vue?vue&type=script&lang=ts&"
import style0 from "./MessageIndex.vue?vue&type=style&index=0&id=0ab5d266&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab5d266",
  null
  
)

export default component.exports